/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import {
	TAILORED_ONBOARDING_BOARD,
	TAILORED_ONBOARDING_CALENDAR,
	TAILORED_ONBOARDING_FORM,
	TAILORED_ONBOARDING_INVITE,
	TAILORED_ONBOARDING_LIST,
	TAILORED_ONBOARDING_PAGES,
	TAILORED_ONBOARDING_SUMMARY,
	TAILORED_ONBOARDING_TIMELINE,
} from '../../../../../common/constants.tsx';
import type { Cards } from '../../../../../common/types.tsx';
import { Experience, TeamType } from '../constants.tsx';

export const DESIGN_VARIANTS: Cards = {
	[TAILORED_ONBOARDING_SUMMARY]: {
		position: { default: -1 },
		visibility: {
			default: false,
		},
	},
	[TAILORED_ONBOARDING_TIMELINE]: {
		position: { default: -1 },
		visibility: {
			default: false,
		},
	},
	[TAILORED_ONBOARDING_LIST]: {
		position: { default: 0 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [TeamType.design],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_CALENDAR]: {
		position: { default: 100 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [TeamType.design],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_PAGES]: {
		position: { default: 200 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experience.fedRamp],
					value: false,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_FORM]: {
		position: { default: 300 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [TeamType.design],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_BOARD]: {
		position: { default: 400 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [TeamType.design],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_INVITE]: {
		position: { default: 500 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [TeamType.design],
					value: true,
				},
			],
		},
	},
};
